import { render, staticRenderFns } from "./ExpandableItemPayments.vue?vue&type=template&id=7c4af60c&scoped=true"
import script from "./ExpandableItemPayments.vue?vue&type=script&lang=js"
export * from "./ExpandableItemPayments.vue?vue&type=script&lang=js"
import style0 from "./ExpandableItemPayments.vue?vue&type=style&index=0&id=7c4af60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4af60c",
  null
  
)

export default component.exports